export enum SupportedReports {
  OVERVIEW = 'OVERVIEW',
  INCOME_EXPENSE = 'INCOME_EXPENSE',
  SPEND_BUDGET = 'SPEND_BUDGET',
  DELINQUENCY = 'DELINQUENCY',
  DIRECTORY = 'DIRECTORY',
}
